// extracted by mini-css-extract-plugin
export default {"footer-container":"styles_footer-container__o19vT"};